var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-button"},[_c('span',{staticClass:"uk-margin-small-right",attrs:{"uk-icon":"icon: cart"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.totalAmount)+" руб.")])])}
var staticRenderFns = []

export { render, staticRenderFns }